import { useState } from 'react'

export default function useAnnouncementModalState() {
    const [formState, setFormState] = useState({ title: '', body: '' })
    const [modal, setModal] = useState({
        edit: false, delete: false
    });

    const handleUpdateFormState = (title, body) => {
        setFormState({ title, body });
    }

    const handleUpdateEditModal = (value) => {
        setModal({...modal, edit: value});
    }

    const handleUpdateDeleteModal = (value) => {
        setModal({...modal, delete: value});
    }

    const handleResetModal = () => {
        setModal({ edit: false, delete: false });
    }
    
    const handleResetForm = () => {
        setFormState({ title: '', body: '' });
    }

    return {
        formState,
        modal,
        updateFormState: handleUpdateFormState,
        updateEditModal: handleUpdateEditModal,
        updateDeleteModal: handleUpdateDeleteModal,
        resetModal: handleResetModal,
        resetForm: handleResetForm
    }
}